import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 5,
	height: 8,
	viewBox: "0 0 5 8",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		transform: "translate(.642 .644)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 4.746,
			height: 1,
			x: -.341,
			y: 4.178,
			transform: "rotate(135 2.031 4.678)"
		}), /* @__PURE__ */ _jsx("rect", {
			width: 4.746,
			height: 1,
			x: -.341,
			y: 1.531,
			transform: "rotate(-135 2.031 2.031)"
		})]
	})
});
export default SvgArrowRight;
